var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show_search)?_c('GlobalSearchMobile'):_vm._e(),_c('div',{staticClass:"banner-container",style:(`background-image: url(${_vm.image})`)}),_c('MenuMobile',{attrs:{"icon":true,"nav":true,"show_user":_vm.show_user}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }